export class ContactMessage {
  constructor(
    id = null,
    name = "",
    email = "",
    message = "",
    status = "new",
    ip_address = "",
    user_agent = "",
    created_at = null,
    updated_at = null
  ) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.message = message;
    this.status = status;
    this.ip_address = ip_address;
    this.user_agent = user_agent;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }
}

export class ContactMessagesResponse {
  constructor(
    status = false,
    messages = [],
    pagination = null,
    stats = null
  ) {
    this.status = status;
    this.messages = messages;
    this.pagination = pagination;
    this.stats = stats;
  }
}

export class ContactStatsResponse {
  constructor(status = false, stats = null) {
    this.status = status;
    this.stats = stats;
  }
}

export class UpdateStatusPayload {
  constructor(status = "") {
    this.status = status;
  }
}

export class BulkUpdatePayload {
  constructor(ids = [], status = "") {
    this.ids = ids;
    this.status = status;
  }
}

export class ContactQueryParams {
  constructor(
    status = null,
    search = "",
    page = 1,
    limit = 20,
    sort_by = "created_at",
    sort_order = "DESC"
  ) {
    this.status = status;
    this.search = search;
    this.page = page;
    this.limit = limit;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
  }
}